import { useCallback } from "react"
import { graphql, useMutation, UseMutationConfig } from "react-relay"
import { useChUpdateReferralMutation as useChUpdateReferralMutationType } from "@/modules/patients/detail/referral/ch/services/__generated__/useChUpdateReferralMutation.graphql"

const updateReferralMutation = graphql`
  mutation useChUpdateReferralMutation($input: Ch_updateReferralLetterInput!) {
    ch_updateReferralLetter(input: $input) {
      ch_ReferralLetter {
        id
        progressNoteId
        careProviderIds
        progressNote {
          pointOfCare {
            careProvider {
              firstName
              lastName
              title
              businessName
              creditorCodeRegister
              city
              postalCode
              streetAddress
            }
          }
        }
        createdAt
        createdBy
        fileId
        fileMetadata {
          documentType
          extension
          lengthInKilobytes
        }
        patientId
        reasoning
        referralId
        signedAt
        updatedAt
        updatedBy
        medicationIds
        conditions
        allergies
        documentLanguage
        concludedAt
        concludedBy
        careProvidersCopyTo {
          businessName
          title
          firstName
          lastName
          streetAddress
          postalCode
          city
        }
        icdDiagnosis {
          id
          isAssociation
          diagnosisCode
          primaryCode
          secondaryCode
          associationType
          text
        }
      }
    }
  }
`

const useChUpdateReferralMutation = () => {
  const [commit, isFlight] = useMutation<useChUpdateReferralMutationType>(updateReferralMutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChUpdateReferralMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChUpdateReferralMutation }
